/**
 * Silly Farm Product Enhancements
 * Amazon-style conversion optimization features
 */

(function() {
  'use strict';

  /**
   * Calculate business days from today
   * @param {number} days - Number of business days to add
   * @returns {Date} - The target date
   */
  function addBusinessDays(days) {
    const date = new Date();
    let count = 0;

    while (count < days) {
      date.setDate(date.getDate() + 1);
      const dayOfWeek = date.getDay();
      // Skip weekends (0 = Sunday, 6 = Saturday)
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        count++;
      }
    }

    return date;
  }

  /**
   * Format date as "Mon, Jan 15"
   * @param {Date} date - Date to format
   * @returns {string} - Formatted date string
   */
  function formatDate(date) {
    const options = {
      weekday: 'short',
      month: 'short',
      day: 'numeric'
    };
    return date.toLocaleDateString('en-US', options);
  }

  /**
   * Initialize delivery estimate display
   */
  function initDeliveryEstimate() {
    const estimateElements = document.querySelectorAll('.sf-delivery-estimate__date');

    estimateElements.forEach(function(element) {
      const minDays = parseInt(element.dataset.minDays, 10) || 3;
      const maxDays = parseInt(element.dataset.maxDays, 10) || 7;

      const minDate = addBusinessDays(minDays);
      const maxDate = addBusinessDays(maxDays);

      // If min and max are same, show single date
      if (minDays === maxDays) {
        element.textContent = formatDate(minDate);
      } else {
        element.textContent = formatDate(minDate) + ' - ' + formatDate(maxDate);
      }
    });
  }

  /**
   * Initialize rating click-to-scroll
   */
  function initRatingScroll() {
    const ratingLinks = document.querySelectorAll('.sf-rating-link');

    ratingLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        const targetId = link.getAttribute('href');
        if (targetId && targetId.startsWith('#')) {
          const target = document.querySelector(targetId);
          if (target) {
            e.preventDefault();
            target.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      });
    });
  }

  /**
   * Update urgency badge on variant change
   */
  function initUrgencyBadgeUpdates() {
    const urgencyBadge = document.querySelector('.sf-urgency-badge');
    if (!urgencyBadge) return;

    // Listen for variant changes via Shopify's native events
    document.addEventListener('variant:changed', function(e) {
      const variant = e.detail.variant;
      if (variant && variant.inventory_quantity) {
        const countElement = urgencyBadge.querySelector('.sf-urgency-badge__count');
        if (countElement) {
          countElement.textContent = variant.inventory_quantity;
        }

        // Show/hide based on inventory
        const threshold = parseInt(urgencyBadge.dataset.threshold, 10) || 10;
        if (variant.inventory_quantity > 0 && variant.inventory_quantity <= threshold) {
          urgencyBadge.style.display = 'inline-flex';
        } else {
          urgencyBadge.style.display = 'none';
        }
      }
    });
  }

  /**
   * Initialize all product enhancements
   */
  function init() {
    initDeliveryEstimate();
    initRatingScroll();
    initUrgencyBadgeUpdates();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also run on Shopify section render (for theme editor)
  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.querySelector('.sf-delivery-estimate__date') ||
        e.target.querySelector('.sf-rating-link') ||
        e.target.querySelector('.sf-urgency-badge')) {
      init();
    }
  });
})();
